import React from 'react'
// utils
import { cn } from '@utils/cn'

// types
import type { children, className } from './types'

export interface DialogFooterProps extends React.ComponentProps<'div'> {
  className?: className
  children: children
}

export const DialogFooter = React.forwardRef<HTMLDivElement, DialogFooterProps>(({ className, children, ...rest }, ref) => {
  // 3. set styles
  const baseClasses = 'flex items-center justify-end shrink-0 flex-wrap p-4 text-blue-gray-500'
  const dialogFooterClasses = cn(baseClasses, className)

  // 4. return
  return (
    <div {...rest} ref={ref} className={dialogFooterClasses}>
      {children}
    </div>
  )
})

DialogFooter.displayName = 'DialogFooter'

export default DialogFooter



